import React, { useEffect, useState, useRef } from 'react';
import { Tabs, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { debounce, isEmpty, trim, filter, compact, sumBy, map, groupBy } from 'lodash';

import Search from '../../../../../../../components/uiComponent/inputs/searchinput';
import AntdAccordionCard from '../../../../../../../components/uiComponent/accordion';

import { StepTwoWrapper, CollapseAbleCardWrapper } from '../../style';
import Card from './Card';
import MultiSkuDrawer from './MultiSkuDrawer';
import AddItemDrawer from './AddItemDrawer';
import AccordionCardsData from './AccordionCardsData';
import ShipmentPallets from './ShipmentPallets';

import { STORAGE_ICON_URL } from '../../../../../../../constants/storage';

const DisLikeIcon = `${STORAGE_ICON_URL}/dis-like.svg`;

const CollapseAbleCard = ({
  boxesList,
  setCreateMultiSKU,
  itemShipmentIndex,
  activeShipmentIndex,
  setDefaultTab,
  filteredBoxesList,
  boxCurrentPage,
  setBoxCurrentPage
}) => {
  return (
    <CollapseAbleCardWrapper>
      <AntdAccordionCard
        cardsData={
          <AccordionCardsData
            boxesList={boxesList}
            setCreateMultiSKU={setCreateMultiSKU}
            itemShipmentIndex={itemShipmentIndex}
            activeShipmentIndex={activeShipmentIndex}
            setDefaultTab={setDefaultTab}
            filteredBoxesList={filteredBoxesList}
            boxCurrentPage={boxCurrentPage}
            setBoxCurrentPage={setBoxCurrentPage}
          />
        }
        title={`Boxe's (${filteredBoxesList?.length || 0})`}
      />
    </CollapseAbleCardWrapper>
  )
};

const StepTwo = ({
  activeShipmentIndex,
  isSubmitPackingInfo,
  setShipmentsData,
  shipmentsData,
  setContactDetails,
  contactDetails,
  deletedPallets,
  setDeletedPallets,
  showTransportGlobal,
  setActiveKey,
  activeKey,
  setTransportationDetails,
  transportationDetails,
  updateShipmentTrackingDetailsLoading,
  deliveryWindowOptionsLoading,
  palletsChangeAllowed,
  setPalletsChangeAllowed,
  setIsSubmitPackingInfo,
  currentPage,
  setCurrentPage
}) => {
  const [boxCurrentPage, setBoxCurrentPage] = useState(1);
  const inputRef = useRef(null);

  const { TabPane } = Tabs;

  const [productInfo, setProductInfo] = useState(false);
  const [isCreateMultiSKU, setCreateMultiSKU] = useState(false);
  const [itemShipmentIndex, setItemShipmentIndex] = useState(0);
  const [productDetail, setProductDetail] = useState({});

  const [itemsList, setItemsList] = useState({ toBeBoxed: [], boxed: [] });
  const [itemIndex, setItemIndex] = useState(-1);
  const [activeTabKey, setActiveTabKey] = useState('1');
  const [itemShipments, setItemShipments] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [boxesList, setBoxesList] = useState([]);
  const [filteredBoxesList, setFilteredBoxesList] = useState([]);
  const [remainingItems, setRemainingItems] = useState([]);

  const { toBeBoxed, boxed } = itemsList || {};

  const {
    shipmentDetails,
    fetchingWarehouseShipments,
  } = useSelector((state) => state.postShipment || {});

  useEffect(() => {
    if (isEmpty(shipmentDetails)) return;

    const allShipmentItems = (activeShipmentIndex === -1) ?
      (shipmentDetails?.shipments?.map(shipment => shipment.shipment_items_info)?.flat() || []) :
      (shipmentDetails?.shipments[activeShipmentIndex].shipment_items_info || []);

    const allBoxes = (activeShipmentIndex === -1) ?
      (shipmentDetails?.shipments?.map(shipment => shipment.boxes_info)?.flat() || []) :
      (shipmentDetails?.shipments[activeShipmentIndex].boxes_info || []);
    const toBeBoxed = [...(allShipmentItems || [])]
      .sort((a, b) => (Number(a?.boxed_quantity || 0) === Number(a?.quantity || 0) ? 1 : -1));

      const remainingItems = (allShipmentItems || []).filter(
        item =>
          item &&
          Number(item.boxed_quantity || 0) !== Number(item.quantity || 0)
      );

    setRemainingItems(remainingItems)

    const boxed = (allShipmentItems || []).filter(item => {
      if (!item) return false;
      const { boxed_quantity = 0, quantity } = item;
      return Number(boxed_quantity) === Number(quantity || 0);
    });

    setActiveTabKey('1');
    setItemsList({ toBeBoxed, boxed });
    setFilteredItems(toBeBoxed);
    setBoxesList(compact(allBoxes));
    inputRef?.current?.value && (inputRef.current.value = '');
  }, [shipmentDetails, activeShipmentIndex]);

  useEffect(() => {
    setFilteredBoxesList(boxesList);
  }, [boxesList]);

  const handleSearch = debounce(({ target }) => {
    const { value } = target || {};

    if (trim(value)) {
      const data = (activeTabKey == '1') ? toBeBoxed : boxed;

      const filteredData = filter(data, item =>
        item?.fnsku?.toLowerCase().includes(value.toLowerCase()) ||
        item?.item_name?.toLowerCase().includes(value.toLowerCase()) ||
        item?.msku?.toLowerCase().includes(value.toLowerCase()) ||
        (item?.product_details || []).some(product =>
          product.identifier_value?.toLowerCase().includes(value.toLowerCase())
        )
      ) || [];

      if (filteredData?.length) {
        setItemIndex(0);
  
        const filteredShipments = (activeShipmentIndex === -1
          ? shipmentDetails.shipments
          : [shipmentDetails.shipments[activeShipmentIndex]]
        ).filter(({ shipment_items_info }) =>
          shipment_items_info.some(({ msku }) => msku === filteredData[0].msku)
        )?.map(({ shipment_items_info, boxes_info, ...shipmentDetails }) => {
          const { boxed_quantity = 0, quantity = 0 } = shipment_items_info.find(({ msku }) => msku === filteredData[0].msku) || {};
          return {
            ...shipmentDetails,
            boxed_quantity,
            quantity
          };
        });

        setItemShipments(filteredShipments);

        if (activeShipmentIndex !== -1) {
          const { amazon_shipment_id } = shipmentDetails?.shipments[activeShipmentIndex] || {};
          setItemShipmentIndex(filteredShipments.findIndex((shipment) => shipment?.amazon_shipment_id === amazon_shipment_id));
        }
      }

      setFilteredItems(filteredData);
      if (filteredData?.length === 1) {
        setProductDetail(filteredData[0]);
        setProductInfo(true);
      }
  
      const filteredBoxList = boxesList.filter(box => 
        (box?.items || []).some(item => 
          filteredData.some(filteredItem => 
            item.shipment_item_id === filteredItem.id // Match box item to filtered item
          )
        )
      );
      setFilteredBoxesList(filteredBoxList);

    } else {
      const defaultData = (activeTabKey == '1') ? toBeBoxed : boxed;
      setFilteredItems(defaultData);
  
      setFilteredBoxesList(boxesList);
    }

    console.log({ boxesList, target });
  }, 800);


  const handleTabChange = (key) => {
    setActiveTabKey(key);
    if (key == '1') setFilteredItems(toBeBoxed);
    else setFilteredItems(boxed);

    inputRef.current.value = '';
  };

  const mergedData = map(groupBy(filteredItems, "msku"), (group) => ({
    ...group[0],
    quantity: sumBy(group, (item) => Number(item?.quantity)),
    boxed_quantity: sumBy(group, (item) => Number(item?.boxed_quantity || 0)),
  })) || [];

  return (
    <>
      {!isSubmitPackingInfo && activeKey !== '3'
      ? 
      <StepTwoWrapper>
        <div className='items'>
          <header>
            {/* <p>Item’s List</p> */}
            <div className='actions'>
              <Search inputRef={inputRef} placeholder="Search by Title, SKU, UPC, FNSKU" className="search-ui-wrapper" onChange={handleSearch} />
              <Tooltip title='Scan'>
                <img src={DisLikeIcon} alt="dis-like-icon" onClick={() => inputRef?.current?.focus()} />
              </Tooltip>
            </div>
          </header>
          {/* <Tabs activeKey={activeTabKey} defaultActiveKey="1">
            <TabPane
              tab={`To be Box (${Math.abs(mergedData?.length - mergedData?.filter(
                ({ boxed_quantity = 0, quantity }) => Math.abs(Number(boxed_quantity)) === Math.abs(Number(quantity))
              ).length)})`}
              key="1"
            > */}
              <Card
                pagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                cardData={filteredItems}
                setProductInfo={setProductInfo}
                setItemIndex={setItemIndex}
                setItemShipments={setItemShipments}
                activeShipmentIndex={activeShipmentIndex}
                setItemShipmentIndex={setItemShipmentIndex}
                setProductDetail={setProductDetail}
              />
            {/* </TabPane> */}
            {/* <TabPane tab={`Boxed (${boxed?.length || 0})`} key="2">
              <Card
                cardData={filteredItems}
                noActions={true}
                setProductInfo={setProductInfo}
              />
            </TabPane> */}
          {/* </Tabs> */}
        </div>
        <CollapseAbleCard
          boxesList={boxesList}
          setCreateMultiSKU={setCreateMultiSKU}
          itemShipmentIndex={itemShipmentIndex}
          activeShipmentIndex={activeShipmentIndex}
          setDefaultTab={() => setActiveTabKey('1')}
          filteredBoxesList={filteredBoxesList}
          boxCurrentPage={boxCurrentPage}
          setBoxCurrentPage={setBoxCurrentPage}
        />
      </StepTwoWrapper> 
      :
        <ShipmentPallets
          contactDetails={contactDetails}
          setContactDetails={setContactDetails}
          shipmentsData={shipmentsData}
          setShipmentsData={setShipmentsData}
          deletedPallets={deletedPallets}
          setDeletedPallets={setDeletedPallets}
          setActiveKey={setActiveKey}
          activeKey={activeKey}
          showTransportGlobal={showTransportGlobal}
          setIsSubmitPackingInfo={setIsSubmitPackingInfo}
          setPalletsChangeAllowed={setPalletsChangeAllowed}
          palletsChangeAllowed={palletsChangeAllowed}
          deliveryWindowOptionsLoading={deliveryWindowOptionsLoading}
          updateShipmentTrackingDetailsLoading={updateShipmentTrackingDetailsLoading}
          setTransportationDetails={setTransportationDetails}
          transportationDetails={transportationDetails}
        />}

      {
        isCreateMultiSKU &&
        <MultiSkuDrawer
          isCreateMultiSKU={isCreateMultiSKU}
          setCreateMultiSKU={setCreateMultiSKU}
          toBeBoxed={remainingItems}
          activeShipmentIndex={activeShipmentIndex}
          boxesList={boxesList}
        />
      }

      {
        productInfo &&
        <AddItemDrawer
          clearSearch={() => inputRef.current.value = ''}
          setProductInfo={setProductInfo}
          productInfo={productInfo}
          itemsList={filteredItems}
          itemShipmentIndex={itemShipmentIndex}
          setItemShipmentIndex={setItemShipmentIndex}
          itemShipments={itemShipments}
          setItemShipments={setItemShipments}
          itemIndex={itemIndex}
          setItemIndex={setItemIndex}
          boxesList={boxesList}
          productDetail={productDetail}
          setProductDetail={setProductDetail}
        />
      }
    </>
  )
}

export default StepTwo
